import { matchPath } from 'react-router-dom'

import { EExportJobType } from '~/features/exports/models'
import { EReportDashboard } from '~/features/reports/models'
import { getReportsPathForDashboard } from '~/features/reports/utils'
import { EClientPath } from '~/models/api'

export default function isOnExportOriginPage(
  type: EExportJobType,
  pathname: string,
): boolean {
  if (type === EExportJobType.contacts) {
    return (
      matchPath({ path: EClientPath.contacts, end: true }, pathname) != null
    )
  }

  return (
    matchPath(
      {
        path: getReportsPathForDashboard(EReportDashboard.download),
        end: true,
      },
      pathname,
    ) != null
  )
}
